import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getAllSchoolsSimpleRequest } from "../../../../Backend/SchoolsRequests";
import { WebRoutes } from "../../../../Constants";
import { SchoolStats } from "../../Common/SchoolStats/SchoolStats";
import { selectSchool } from "../../../../Reducer";
import { hasValue } from "../../../../Helpers/validations/common";
import "./UserHomePage.scss";

export function UserHomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [schoolList, setSchoolList] = useState([]);
  const [loading, setLoading] = useState(false);
  const school = useSelector((state) => state.school);

  useEffect(() => {
    getSchoolsList();
  }, []);

  const getSchoolsList = async () => {
    setLoading(true);
    const resp = await getAllSchoolsSimpleRequest();

    if (resp.success) {
      if (!hasValue(school.id)) {
        dispatch(selectSchool(resp.data[0]));
      }
      setSchoolList(resp.data);
      setLoading(false);
    }
  };

  return (
    <div className="user-home-page trans-fromTop">
      {schoolList.length > 0 ? (
        <React.Fragment>
          <span className="title">{t("AdminDashboard")}</span>
          <SchoolStats
            loading={loading}
            schoolList={schoolList}
            schoolSelected={school}
            setSchoolSelected={(sc) => dispatch(selectSchool(sc))}
            setLoading={setLoading}
          />
        </React.Fragment>
      ) : (
        loading === false && (
          <div className="no-schools-asigned-wrapper">
            <div className="no-schools-title">{t("NoSchoolsAsigned")}</div>
            <div className="no-schools-text">{t("NoSchoolsAsignedText")}</div>
            <Button
              className="button-profile"
              onClick={() => navigate(WebRoutes.UserProfilePage)}
            >
              {t("Profile")}
            </Button>
          </div>
        )
      )}
    </div>
  );
}
